import React from "react";
import PropTypes from "prop-types";
import { Flex, Text } from "@fluentui/react-northstar";
import { observer } from "mobx-react-lite";

const ReadOnlyTextField = observer((props) => {
  const { label, text, testId } = props;

  return (
    <Flex column data-testid={testId}>
      <Text
        className="body-text"
        data-testid={testId + "Label"}
        content={label}
      />
      <Text className="body-text" data-testid={testId + "Text"} content={text} />
    </Flex>
  );
});

ReadOnlyTextField.propTypes = {
  label: PropTypes.string,
  text: PropTypes.string,
  testId: PropTypes.string,
};

ReadOnlyTextField.defaultProps = {
  label: "",
  text: "",
  testId: "",
};

export default ReadOnlyTextField;
